import { useState } from 'react';
import { Button, Input } from "@repo/o37-ui";
import { supabase } from "../supabaseClient";

export default function MFAChallenge({ factorId, onSuccess, onCancel }: { factorId: string, onSuccess: () => void, onCancel: () => void }) {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const verify = async (e?: React.FormEvent) => {
    e?.preventDefault();
    try {
      setLoading(true);
      setError('');
      
      const { error } = await supabase.auth.mfa.challengeAndVerify({
        factorId,
        code
      });
      
      if (error) throw error;

      onSuccess();
    } catch (e: any) {
      setError(e.message || 'Invalid code. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full">
      <h2 className="text-xl font-semibold mb-2 text-center">Two-Factor Authentication</h2>
      <p className="text-neutral-600 text-sm mb-6 text-center">
        Enter the 6-digit code from your authenticator app.
      </p>

      <form onSubmit={verify} className="space-y-4">
        <div className="flex justify-center">
            <Input 
                value={code}
                onChange={e => setCode(e.target.value)}
                placeholder="000000"
                className="text-center tracking-widest font-mono text-2xl h-14 w-48"
                maxLength={6}
                autoFocus
            />
        </div>
        
        {error && <div className="text-red-600 text-sm text-center">{error}</div>}

        <div className="space-y-3 pt-2">
            <Button 
                type="submit" 
                className="w-full justify-center" 
                disabled={loading || code.length !== 6} 
                text={loading ? "Verifying..." : "Verify"} 
            />
            <button 
                type="button"
                onClick={onCancel}
                className="w-full text-center text-sm text-neutral-500 hover:text-neutral-800"
            >
                Back to Login
            </button>
        </div>
      </form>
    </div>
  );
}
